import { render, staticRenderFns } from "./style-1.vue?vue&type=template&id=3db0a0c4&scoped=true"
import script from "./style-1.vue?vue&type=script&lang=js"
export * from "./style-1.vue?vue&type=script&lang=js"
import style0 from "./style-1.vue?vue&type=style&index=0&id=3db0a0c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db0a0c4",
  null
  
)

export default component.exports